import { ReactComponent as SteamSvg } from './steam_icon.svg';

function SteamIcon({ size = 20, className }) {
  return (
    <SteamSvg
      width={size}
      height={size}
      aria-hidden
      className={className}
      style={{ display: 'block', flexShrink: 0, fill: 'currentColor' }}
    />
  );
}

export default SteamIcon;
